<template>
    <div class="fixed-button">
        <a id="toTopIcon" href="#banner" v-show="show">
            <img src="@/assets/spacecraft.png">
            To Top
        </a>
    </div>
    
</template>

<script>
export default {
    data() {
        return {
            show: false,
        };
    },

    methods: {
        handleScroll: function(){
            if (window.pageYOffset > 350) this.show = true;
            else this.show = false;
        },
    },

    mounted() {
        window.addEventListener('scroll', this.handleScroll)
    },

}
</script>

<style scoped>
.fixed-button {
    position: fixed;
    bottom: 0;
    right: 10px;
    height: 50px;
    margin-bottom: 36px;
    z-index: 100;
}

.fixed-button img {
    display: block;
    height: 46px;
    margin: 8px auto;
    background-size: cover;
}

a {
    color: var(--blue);
    font-size: 14px;
    font-weight: 400;
    text-decoration: none;
    line-height: normal
}

@media  screen and (min-width: 993px) {
    .fixed-button {
        bottom: 10px;
        right: 20px;
    }

    a {
        font-size: 18px;
    }
}
</style>

